import { useEffect, useRef, useState } from "react";
import { ProductServices } from "../../services/products";
import { Icon } from "../Icon";
import Table from "../Table";
import "./CatalogOnPage.scss";
import { ToastContainer } from "react-toastify";
import ReactToPrint from "react-to-print";
type Props = {
  products: CatalogProduct[];
  catalog: string;
  manufacturingCost?: ManufacturingCost[];
};

// Create Document Component
const CatalogOnsection: React.FC<Props> = ({ products, catalog }) => {
  const labels: LenghtLabel = ProductServices.getProductsLabels(
    products[0].category,
    products[0].department,
    products[0].isCustom
  );
  let componentRef = useRef<HTMLDivElement>(null);
  const [processProducts, setProcessProducts] = useState<CatalogProduct[]>();
  const [showTable, setShowTable] = useState<boolean>(false);

  useEffect(() => {
    // this should be on new functions or helpers to construct this.
    // as it is, this becomes untesteable
    let auxProcessProducts: CatalogProduct[] = [];
    products.forEach((product) => {
      let weights: string[][] = [];
      let gaugesAux: string[] = [];
      let lengthAux: string[] = [];
      if (
        (product.department === "chain" ||
          product.department === "brazalete") &&
        product.category.includes("solid")
      ) {
        setShowTable(true);
        product.variations.forEach((el) => {
          !gaugesAux.some((some) => some == el.gauge) &&
            gaugesAux.push(el.gauge);
          !lengthAux.some((some) => some == el.length) &&
            lengthAux.push(el.length);
        });
        gaugesAux.sort(), lengthAux.sort();
        for (let j = 0; j < gaugesAux.length; j++) {
          let arrayAuxiliar: string[] = [];
          arrayAuxiliar.push(gaugesAux[j]);
          for (let i = 0; i < lengthAux.length; i++) {
            let found = product.variations.find(
              (el) => el.gauge == gaugesAux[j] && el.length == lengthAux[i]
            );
            found?.weight
              ? arrayAuxiliar.push(found?.weight)
              : arrayAuxiliar.push(" ");
          }
          weights.push(arrayAuxiliar);
        }

        auxProcessProducts.push({
          ...product,
          table: {
            table: weights,
            gauges: gaugesAux,
            lengths: lengthAux,
          },
        });
      } else {
        setShowTable(false);
        product.variations.sort((a, b) => {
          const colorComparison = a.color.localeCompare(b.color);
          const gaugeComparison = a.gauge.localeCompare(b.gauge);

          if (colorComparison !== 0) {
            return colorComparison;
          } else if (gaugeComparison !== 0) {
            return gaugeComparison;
          } else {
            return Number(a.length) - Number(b.length);
          }
        });
        auxProcessProducts.push(product);
      }
    });
    setProcessProducts(auxProcessProducts);
  }, []);

  const translate = (catalog: string) => {
    switch (catalog) {
      case "all":
        return "Catálogo completo";
      case "ring":
        return "Anillos";
      case "pendant":
        return "Dijes";
      case "hoop":
        return "Aros";
      case "finding":
        return "Fornituras";
      case "brazalete":
        return products[0].category.includes("solid")
          ? "Pulseras Macizas"
          : "Otras Pulseras";
      case "chain":
        return products[0].category.includes("solid")
          ? "Cadenas Macizas"
          : "Otras Cadenas";
      case "gold":
        return "Oro";
      case "silver":
        return "Plata";
      default:
        return "catalogo";
    }
  };

  return (
    <>
      <ToastContainer position="top-right" autoClose={500} hideProgressBar />
      <div className="downloadButton">
        <ReactToPrint
          trigger={() => {
            // NOTE: could just as easily return <SomeComponent />. Do NOT pass an `onClick` prop
            // to the root node of the returned component as it will be overwritten.
            return <a href="#">Imprimir</a>;
          }}
          content={() => componentRef.current}
        />
      </div>
      <div className="styles_page" id="reportContent" ref={componentRef}>
        <section className="styles_section">
          <div className="styles_header">
            <p>
              {translate(catalog)[0].toUpperCase() +
                translate(catalog).slice(1)}
            </p>
            <Icon iconName="rtabak_icon" className="nav__icon" />
          </div>

          {processProducts && processProducts.length > 0 && (
            <div className="styles_section">
              {!showTable && (
                <div className="styles_head">
                  <p className="styles_short">Código</p>
                  <p className="styles_short"></p>
                  <p className="styles_long">Descripción</p>
                  <p className="styles_short">Material</p>
                  <p className="styles_short">Color</p>
                  <p className="styles_short">{labels.gaugeLabel}</p>
                  <p className="styles_short">{labels.lenghtLabel}</p>
                  <p className="styles_short">Peso</p>
                  {/*
                  <p className="styles_short">Hechura</p>*/}
                </div>
              )}
              {processProducts.map((el) => {
                return (
                  <>
                    {showTable ? (
                      <div className="styles_head_table">
                        <img
                          src={el.thumbnailUrl.split("|")[0]}
                          alt=""
                          onError={({ currentTarget }) => {
                            currentTarget.onerror = null; // prevents looping
                            currentTarget.src =
                              "https://assets.rtabak.com.ar/rtabak.png";
                          }}
                        />
                        <div className="styles_head_table_data">
                          <h3>{el.title}</h3>
                          <div className="styles_head_table_data_detail">
                            <p>{"Código: " + el.sku}</p>
                            <p>{"Material: " + translate(el.material)}</p>
                          </div>
                        </div>
                      </div>
                    ) : (
                      <div className="styles_data" key={el._id}>
                        <p className="styles_short">{el.sku}</p>
                        <div className="image_container">
                          {el.thumbnailUrl ? (
                            <img
                              src={el.thumbnailUrl.split("|")[0]}
                              onError={({ currentTarget }) => {
                                currentTarget.onerror = null; // prevents looping
                                currentTarget.src =
                                  "https://assets.rtabak.com.ar/rtabak.png";
                              }}
                            />
                          ) : (
                            <p />
                          )}
                        </div>
                        <p className="styles_long">{el.title}</p>
                        <p className="styles_short">{translate(el.material)}</p>

                        <p className="styles_short">
                          {el.variations[0]
                            ? el.variations[0].color[0].toUpperCase() +
                              el.variations[0].color.slice(1)
                            : "N/A"}
                        </p>
                        <p className="styles_short">
                          {el.variations[0] ? el.variations[0].gauge : "N/A"}
                        </p>
                        <p className="styles_short">
                          {el.variations[0] ? el.variations[0].length : "N/A"}
                        </p>
                        <p className="styles_short">
                          {el.variations[0]
                            ? el.variations[0].weight + "gr"
                            : "N/A"}
                        </p>
                        {/*
                        <p className="styles_short">
                          {el.variations[0]
                            ? manufacturingCost &&
                              (manufacturingCost.find(
                                (mc) =>
                                  mc._id == el.variations[0].manufacturingCostId
                              )?.value == 0
                                ? "A consultar"
                                : "$" +
                                  manufacturingCost
                                    .find(
                                      (mc) =>
                                        mc._id ==
                                        el.variations[0].manufacturingCostId
                                    )
                                    ?.value.toFixed(2))
                            : "N/A"}
                        </p>*/}
                      </div>
                    )}
                    {el.table ? (
                      <div
                        style={{
                          paddingLeft: "16px",
                          paddingBottom: "32px",
                          marginBottom: "48px",
                          borderBottom: "1px solid #ebebec",
                          marginTop: "-16px",
                        }}
                      >
                        <Table
                          lengths={el.table.lengths}
                          table={el.table.table}
                          vertical={
                            ProductServices.getProductsLabels(
                              el.category,
                              el.department,
                              el.isCustom
                            ).gaugeTable
                          }
                          horizontal={
                            ProductServices.getProductsLabels(
                              el.category,
                              el.department,
                              el.isCustom
                            ).lenghtTable
                          }
                          unit={
                            ProductServices.getProductsLabels(
                              el.category,
                              el.department,
                              el.isCustom
                            ).unit
                          }
                        />
                      </div>
                    ) : (
                      el.variations.slice(1).length > 0 &&
                      el.variations.slice(1).map((v) => {
                        return (
                          <div className="styles_data" key={el._id}>
                            <p className="styles_short"></p>

                            <p style={{ width: "10%", marginBottom: "10px" }} />

                            <p className="styles_long"></p>
                            <p className="styles_short"></p>
                            <p className="styles_short">
                              {v.color[0].toUpperCase() + v.color.slice(1)}
                            </p>
                            <p className="styles_short">{v.gauge}</p>
                            <p className="styles_short">{v.length}</p>
                            <p className="styles_short">{v.weight + "gr"}</p>
                            {/*
                            <p className="styles_short">
                              {manufacturingCost
                                ? manufacturingCost.find(
                                    (mc) => mc._id == v.manufacturingCostId
                                  )?.value == 0
                                  ? "A consultar"
                                  : "$" +
                                    manufacturingCost
                                      .find(
                                        (mc) => mc._id == v.manufacturingCostId
                                      )
                                      ?.value.toFixed(2)
                                : "N/A"}
                                      </p>*/}
                          </div>
                        );
                      })
                    )}
                  </>
                );
              })}
            </div>
          )}
          <div className="styles_footer">
            <p>Libertad 262 local 11</p>
            <p>Buenos aires - Argentina</p>
            <p>Tel.: +54(11)54118520 - info@rtabak.com.ar</p>
          </div>
        </section>
      </div>
    </>
  );
};

export default CatalogOnsection;
